import { useAuth } from '../../lib/auth';
import MonthlyExpensesView from '../../components/MonthlyExpensesView';

export default function MonthlyExpenses() {
  const { user } = useAuth();
  return <MonthlyExpensesView role={user?.role || 'account'} />;
}
